import { AliasProductInput } from "../types/AliasProduct";
import { Hint } from "@/ui/Hint";
import AliasProductForm from "./AliasProductForm";
import { useCreateAliasProduct } from "../useCases/useCreateAliasProduct";
import {
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogHeader,
  DialogRoot,
  DialogTitle,
} from "@/ui/chakra/dialog";

interface CreateAliasProductModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const CreateAliasProductModal = ({
  isOpen,
  onClose,
}: CreateAliasProductModalProps) => {
  const { mutate } = useCreateAliasProduct();

  const handleCreateAliasProduct = (data: AliasProductInput) => {
    const newAliasProductData = {
      ...data,
    };
    mutate(newAliasProductData);
    onClose();
  };

  return (
    <DialogRoot isOpen={isOpen} onClose={onClose} isCentered size="lg">
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Crear alias de producto</DialogTitle>
        </DialogHeader>
        <DialogCloseTrigger />
        <DialogBody pb={0} display="flex" flexDirection="column" gap={5}>
          <Hint>
            Un alias es otro nombre o código para buscar un producto que ya
            existe, por ejemplo el que usa el cliente o el proveedor. Al
            elegirlo en un vale se agrega el producto real.
          </Hint>
          <AliasProductForm
            onSubmit={handleCreateAliasProduct}
            onCancel={onClose}
          />
        </DialogBody>
      </DialogContent>
    </DialogRoot>
  );
};
